import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=ec03d2c2&scoped=true&"
import script from "./MainView.vue?vue&type=script&lang=js&"
export * from "./MainView.vue?vue&type=script&lang=js&"
import style0 from "./MainView.vue?vue&type=style&index=0&id=ec03d2c2&lang=scss&scoped=true&"
import style1 from "./MainView.vue?vue&type=style&index=1&id=ec03d2c2&lang=scss&scoped=true&"
import style2 from "./MainView.vue?vue&type=style&index=2&id=ec03d2c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec03d2c2",
  null
  
)

export default component.exports